import React, {useEffect} from 'react'
import {PricingListTable} from "./PricingListTable";

import PricingListBrands from "./PricingListBrands";
import Box from "@mui/material/Box";
import {PricingListTableSearchBarHeader} from "./PricingListSearchBarHeader";
import {useUserContext} from "../../contexts/UserContext";
import {useUIContext} from "../../contexts/UIContext";
import {PricingListPageMobile} from "./PricingListPageMobile/PricingListPageMobile";
import {useMediaQuery} from "react-responsive";
import {useParams} from "react-router";
import {useShallow} from "zustand/react/shallow";
import {usePricingsStore} from "../../stores/pricingsStore";
import {searchPricings} from "../../utils/utils";
import {useDebounce} from "@uidotdev/usehooks";
import useDidMountEffect from "../../hooks/useDidMountEffect";

export const brandsWidth = 150
export const headerHeight = 160

export const PricingListPage = () =>  {
    const params = useParams();
    const { uiState } = useUIContext()
    const {sideNavDrawerWidth} = uiState
    const { profileState } = useUserContext()
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })

    const {
        pricingData,
        setPricingData,
        fetchPricings,
        isLoading,
        search,
    } = usePricingsStore(
        useShallow((state) => ({
            pricingData: state.pricingData,
            setPricingData: state.setPricingData,
            fetchPricings: state.fetchPricings,
            isLoading: state.isLoading,
            search: state.search,
        }))
    )

    const debouncedSearch = useDebounce(search, 500)

    const buildParams = (search) => {
        let queryParams = new URLSearchParams({})

        if (search.length) {
            queryParams.append("s", search)
        }

        return queryParams
    }

    useEffect(() => {
        setPricingData([])
        fetchPricings(params.make)
    }, [params.make])

    useDidMountEffect(function fetchPricingsOnSearch() {
        fetchPricings(params.make, buildParams(debouncedSearch))
    }, [debouncedSearch])

    useEffect(() => {
        return () => {
            setPricingData([])
        }
    }, [])

    const page = () => {
        if (isTabletOrMobile) {
            return <PricingListPageMobile make={params.make}/>
        }

        return (
            <React.Fragment>
                {
                    profileState &&
                    <Box
                        style={{
                            width: `${brandsWidth}px`,
                        }}
                    >
                        <PricingListBrands
                            makesList={profileState.makes_list}
                        />
                    </Box>
                }
                <Box
                    style={{
                        flexGrow: 1,
                        bgcolor: 'background.default',
                        width: `calc(100% - ${brandsWidth}px)`,
                        padding: '0 15px',
                        opacity: isLoading ? .5 : 1
                    }}
                >
                    <Box
                        style={{
                            width: `calc(100% - ${brandsWidth + sideNavDrawerWidth}px)`,
                            zIndex: 11,
                            position: 'fixed',
                            // height: '100dvh',
                            background: "#FFFFFF",
                            padding: '0 72px 0 0', // this padding is to account for the 0 36px above
                        }}
                    >
                        <PricingListTableSearchBarHeader
                            make={params.make}
                            headerHeight={headerHeight - 40}
                        />
                    </Box>
                    <Box style={{ paddingTop: '120px'}}>
                        <PricingListTable
                            pricingData={pricingData}
                            headerHeight={headerHeight}
                        />
                    </Box>
                </Box>
            </React.Fragment>
        )
    }

    return (
        <div id="PricingListPage">
            { page() }
        </div>
    );
}
